// extracted by mini-css-extract-plugin
module.exports = {"root":"_2IHyM","line":"_3Q2Xt"};